
function CockpitSelection() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Selection <br/>
    /// It does
    /// <br/>
    /// Author: ARF<br />
    /// Date: 27.7.2021<br />
    /// Copyright ©: EUDT GmbH 2021 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 27.7.2021                                                *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    
    this.date = getCurrentTimestamp();
    this.userOptions = new vcUserOptions();
    this.editDialog;
    
    this.myDiv;
    this.myHomeSignalDialog;
    this.myHomeSignalDialogDiv;
}

CockpitSelection.prototype = new vcTemplate();

CockpitSelection.prototype.init = function () {
    /// <summary>
    /// This function fetches existing user options and prepares the initial settings.
    /// </summary>
    var me = this;
    var bFound = false;
    try {
        me.initVisuals();

        if (me.isAdmin) {
            //build the edit form
            me.initEditDialog();
            //initiates the edit button
            me.visual.find("#div-edit").off("click").on("click",
                function() {
                    me.myDiv.find("#div-url input, .div-name input").removeClass("formItemInvalid txtEnabled")
                        .addClass("txtEnabled");
                    me.myDiv.find(".error").hide();
                    me.editDialog.dialog("open");
                });
        }
        //set the user options
        me.userOptions.getUserOptions({ 'optgroupid': 'cockpitselection' }, function (result) {
        
            if (result !== null) { 
            if (result.rows !== null) {

                for (var i = 0; i < result.rows.length; i++) {
                    if (result.rows[i].optid === 0) {

                        if (me.visual.find("#div-menu .button-toggle[data-index=" + result.rows[i].dval + "]").length >0) {

                            me.loadContent(result.rows[i].dval);
                            bFound = true;
                        } else {
                            me.loadContent(parseInt(me.visual.find("#div-menu .button-toggle").data("index")));
                            me.userOptions.setUserOptions({ 'optgroupid': 'cockpitselection', 'optid': 0, 'dval': 0 }, function() {});
                            bFound = true;
                        }
                    }
                }
            } else {
                bFound = false;
                }
            } else {
                bFound = false;
            }
            if (bFound === false) { me.loadContent(parseInt(me.visual.find("#div-menu .button-toggle").data("index")));}
          
            if ((me.visual.find("#div-menu .button-toggle").length > 1 || me.isAdmin) && me.mobile === false) {
                me.visual.find("#div-menu").show();
            }
            return true;
        });

    } catch (ex) { me.writeError('initUserOptions', ex); }

}

CockpitSelection.prototype.initVisuals = function () {
    /// <summary>
    /// This function initiates the menu click handler . 
    /// </summary>
    var me = this;
  
    try {
        if (me.error) { return false; }

        me.showInfo("", "", false);

        me.visual.find("#div-menu .button-toggle").off("click").on("click", function () {
            var index = parseInt($(this).data("index"));
            me.userOptions.setUserOptions({
                'optgroupid': 'cockpitselection',
                'optid': 0,
                'dval': index
            }, function() {});
            me.loadContent(index);
         
        });
        me.visual.find("#div-menu .button-toggle").button();

        me.initMyHomeSignalDialog();
        me.visual.find("#div-menu #div-btn-homesignal").off("click").on("click", function () {

            me.myHomeSignalDialog.dialog("open");
            me.vcVisual.addVisualBaseByName('divdialogho', 'VISUAL_MEMBERSHIP_ASSIGNMENT_USER_HOME_SIGNAL', 'mesignals', getCurrentTimestamp(), parseInt(me.myHomeSignalDialog.height, 10)-60, parseInt(me.myHomeSignalDialog.width, 10)-20, "", "", 1);

        });



        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

 
CockpitSelection.prototype.initEditDialog = function () {
    /// <summary>
    /// This function builds the menu form. 
    /// </summary>
    var me = this;

    try {

        //get the current menu settings
        var menu = JSON.parse(me.startMenu);

        me.myDiv = $("<div id='div-dialog'>").addClass("").html($("<span>").css("font-weight", "bold").html(me.resources.editMenu));
        me.myDiv.append($("<div>").addClass("info").html(me.resources.sortingByDragAndDrop));
        me.myDiv.append($("<div>").addClass("error").html(""));
        var header = $("<div>").addClass("vc-list-header color-bg-secondary");
       
        header.append($("<div>").addClass("vc-list-item")
            .append($("<div>").addClass("vc-list-element").css("float", "left").html(me.resources.show))
            .append($("<div>").addClass("vc-list-element").css("float", "right").html(me.resources.mobile)));



        me.myDiv.append($("<div>").append($("<div>").addClass("vc-list").append(header)));
        var lst = $("<ul>").attr("id", "lst-cockpit-selection-edit");


        var chkTachoMobile = $("<input>").prop({
            class: 'chk-mobile',
            type: 'radio',
            id: 'chkMobileTacho',
            name: 'switchmobile',
            checked: "checked",
            value: "1"

        });

        var chkFrameMobile = $("<input>").prop({
            type: 'radio',
            class: 'chk-mobile',
            id: 'chkMobileFrame',
            name: 'switchmobile',
            value: "1"
        });

        var chkListMobile = $("<input>").prop({
            type: 'radio',
            class: 'chk-mobile',
            id: 'chkMobileList',
            name: 'switchmobile',
            value: "1"
        });


        for (var i = 0; i < menu.length; i++) {
           
            switch (menu[i].Index) {
            case 0:
                var item0 = $("<li>").attr("id", "item0").data("type", "tacho").data("index", "0");
                    item0.append($("<input>").attr("type", "checkbox").addClass("on").prop("checked", menu[i].Active));
                    item0.append(chkTachoMobile.prop("checked", menu[i].Mobile));
                    item0.append($("<div>").addClass("div-name").html(me.resources.menuTitle0));
                lst.append(item0);
                    break;
                case 1:

                    var item1 = $("<li>").attr("id", "item1").data("type", "home").data("index", "1");
                    item1.append($("<input>").attr("type", "checkbox").addClass("on").prop("checked", menu[i].Active));
                    item1.append($("<div>").addClass("div-name").html(me.resources.menuTitle1));
                    lst.append(item1);
                    break;

                case 2:

                    var item2 = $("<li>").attr("id", "item2").data("type", "frame").data("index", "2");
                    item2.append($("<input>").attr("type", "checkbox").addClass("on").prop("checked", menu[i].Active));
                    item2.append(chkFrameMobile.prop("checked", menu[i].Mobile));

                    item2.append($("<div>").addClass("div-name").html(me.resources.menuTitle2 + ": ").append($("<input>").addClass("txtEnabled").val(menu[i].FrameCaption)));
                    item2.append($("<div>").attr("id", "div-url").append("iFrame-Url: ").append($("<input>").addClass("txtEnabled").val(menu[i].Url)));
                    lst.append(item2);
                    break;
                case 3:
                    var item3 = $("<li>").attr("id", "item0").data("type", "simplelist").data("index", "3");
                    item3.append($("<input>").attr("type", "checkbox").addClass("on").prop("checked", menu[i].Active));
                    item3.append(chkListMobile.prop("checked", menu[i].Mobile));
                    item3.append($("<div>").addClass("div-name").html(me.resources.menuTitle3));
                    lst.append(item3);
                    break;
            default:
            }
        }


        me.myDiv.append(lst);
        lst.sortable({placeholder: 'formSortPlaceholder', forcePlaceholderSize: true, helper: 'clone'});
        lst.disableSelection();


        me.editDialog = me.myDiv.dialog({
            autoOpen: false,
            width: 600,
            height: 550,
            modal: true,
            buttons: {
                "ok": function () { me.save();},
                "cancel": function () { me.editDialog.dialog('close'); }
            },
           
            dialogClass: 'saveDialog'
        });
     
        return true;
    } catch (ex) {
        me.writeError('initEditDialog', ex);
        return false;
    }
};


CockpitSelection.prototype.initMyHomeSignalDialog = function () {
    /// <summary>
    /// This function builds the menu form. 
    /// </summary>
    var me = this;

    try {

        var size = me.getPopupSize(0.95, 0.95);
        var w = 990;
        var h = size[1];

            me.myHomeSignalDialog = null;
        me.myHomeSignalDialogDiv = $("<div>").attr("id", "divdialoghomesignals").css("z-index", 10000).html(me.vcC.getLoadingIcon());
            if (typeof (myClass) !== "undefined") {
                me.myHomeSignalDialogDiv.addClass(myClass);
            }


            var options = {
                autoOpen: false,
                width: w,
                height: h,
                modal: true,
                dialogClass: "modal-popup-dialog",   // "modal-popup-dialog"

            };

                options.buttons = [{
                    text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                        me.myHomeSignalDialog.dialog('close');
                        if (typeof (onClose) !== "undefined") onClose();
                        return true;
                    }
                }];
  

            me.myHomeSignalDialog = me.myHomeSignalDialogDiv.dialog(options);
            me.myHomeSignalDialog.width = w;
            me.myHomeSignalDialog.height = h;

        return true;
    } catch (ex) {
        me.writeError('initMyHomeSignalDialog', ex);
        return false;
    }
};


// ReSharper disable once UnusedParameter
CockpitSelection.prototype.changeDate = function (obj) {}


CockpitSelection.prototype.loadContent = function (index) {
    /// <summary>
    /// This function loads the contents based on the selected button
    /// </summary>
    var me = this;
    var content;
    var container;
    try {
        if (me.error) { return false; }


        content = me.visual.find("#div-content");
        container = me.getRandomIDContainerObj("div-content-", true);
        me.visual.find("#div-content").html(container.obj);

        switch (index) {
        case 0:
            me.vcVisual.addVisualBaseByName(container.prefix, "CONTAINER_TACHO_SUMSIGNALS", container.random, getCurrentTimestamp(), parseInt(content.height(), 10), parseInt(content.width(), 10), "", JSON.stringify({ 'UsePrices': me.usePrices, 'Interval': 1 }), me.deviceType);
                break;
            case 1:
                me.vcVisual.addVisualBaseByName(container.prefix, 'VISUAL_COCKPIT1', container.random, getCurrentTimestamp(), parseInt(content.height() - 50, 10), parseInt(content.width(), 10), JSON.stringify({'Interval':3, 'UsePrices': me.usePrices, 'HidePriceIcon': true }), "", me.deviceType);
                break;

            case 2:
               
                me.vcVisual.addVisualBaseByName(container.prefix, 'VISUAL_WASSERTIROL_MAP', container.random, getCurrentTimestamp(), parseInt(content.height() - 50, 10), parseInt(content.width(), 10), "", "", me.deviceType);

                break;
        case 3:
                me.vcVisual.addVisualBaseByName(container.prefix, "VISUAL_HOME_SIGNAL_LIST", container.random, getCurrentTimestamp(), parseInt(content.height(), 10), parseInt(content.width(), 10), "", JSON.stringify({ 'UsePrices': me.usePrices, 'Interval': 1 }), me.deviceType);
            break;
        default:
        }
      

        me.toggleButtons(index);

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false }

}


CockpitSelection.prototype.toggleButtons = function (index) {
    /// <summary>
    /// This function switches the active buttons. 
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }

        me.visual.find("#div-menu .button-toggle").removeClass("button-toggle-active");
        me.visual.find("#div-menu .button-toggle[data-index=" + index + "]").addClass("button-toggle-active");
     
        return true;
    } catch (ex) { me.writeError('toggleButtons', ex); return false }

}

CockpitSelection.prototype.save = function () {
    /// <summary>
    /// Saves the data.<br/>
    /// </summary>
    var me = this;
   
    var bValid = true;
    try {
      

        var param = [];


        if (me.myDiv.find("#lst-cockpit-selection-edit .on:checked").length === 0) {
            me.myDiv.find(".error").html(me.resources.pleaseSelectAtLeastOneEntry).show();
          
            return false;
        }

        me.myDiv.find("#lst-cockpit-selection-edit li").each(function() {
           

            var item = {}
            item.index = parseInt($(this).data("index"));
            item.active = $(this).find(".on").prop("checked");

            if ($(this).find(".chk-mobile").length >0) {
                item.mobile = $(this).find(".chk-mobile").prop("checked");
            } else {
                item.mobile = false;
            }
            if ($(this).find("#div-url input").length >0) {
            item.url = $(this).find("#div-url input").val();
            } else {
                item.url = "";
            }
            if ($(this).find(".div-name input").length > 0) {
                item.FrameCaption = $(this).find(".div-name input").val();
            } else {
                item.FrameCaption = "";
            }

            if ($(this).data("type") === "frame") {
              
                if (item.active || item.mobile) {
                    if (item.FrameCaption.length === 0) {
                        me.myDiv.find(".error").html(me.resources.Err_noName).show();

                     
                        $(this).find(".div-name input").removeClass("formItemInvalid txtEnabled")
                            .addClass("formItemInvalid");
                        bValid = false;
                    } 
                    if (item.url.length === 0) {
                        me.myDiv.find(".error").html(me.resources.Err_noUrl).show();
                      
                        $(this).find("#div-url input").removeClass("formItemInvalid txtEnabled")
                            .addClass("formItemInvalid");
                        bValid = false;
                    } 
                }
            }

            param.push(item);
        
        });

        if (bValid === false) { return false;}
    
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(param), function (result) {
          

            if (result !== null) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                  
                } else {
                  
                    me.editDialog.dialog('close');
                    location.reload();
                }
            }

        });
       
    } catch (ex) {
        me.writeError('save', ex);
   
    }
};